<template>
    <div class="component-settings-cycles">
        <div class="el-card__header text-left border" style="margin-left: 225px;" slot="header" v-if="$store.state.general.settingsMenuMode === 'vertical'">
            <h4>{{$route.path.split('settings/')[1] | formatVariableName}}</h4>
        </div>
        <div class="el-card__header text-left border" slot="header" v-else>
            <h4>{{$route.path.split('settings/')[1] | formatVariableName}}</h4>
        </div>
        <el-card class="box-card" id="main-header" shadow="never"
                 style="border: none; border-radius: 0px; min-height: 400px; background-color: #f4f7fa;"
                 body-style="background-color: #f4f7fa; padding: 20px 0px;"
        >
            <div class="row">
                <div class="col-12">
                    <el-card class="box-card text-left" shadow="never" v-loading="!loaded" style="min-height: 200px;">
                        <div class="row">
                            <div class="col-12">
                                <el-button class="fr ml-10" type="primary" @click="addCycle" @submit.prevent="submit" icon="el-icon-plus">New cycle</el-button>
                            </div>
                        </div>
                        <el-tabs v-model="activeName" v-if="cycles.length > 0">
                            <el-tab-pane v-for="cycle of cycles" :key="cycle.cycle_id" :label="cycle.jobs[0].properties.cycle_name" :name="String(cycle.cycle_id)">
                                <template>
                                    <div class="row">
                                        <div class="col-6">
                                            <el-alert
                                                v-show=cycleSaved
                                                title="Cycle saved"
                                                type="success"
                                            >
                                            </el-alert>
                                        </div>
                                        <div class="col-6">
                                            <el-button class="fr ml-10" type="primary" @click="saveCycle" :loading="saving" @submit.prevent="submit" icon="el-icon-upload">Save</el-button>
                                            <el-button class="fr ml-10" type="danger" @click="openWarning" @submit.prevent="submit" v-if="isAdmin === true" icon="el-icon-delete">Delete</el-button>
                                        </div>
                                    </div>
                                    <div class="row" style='margin-top:20px;'>
                                        <div class="col-12">
                                            <p class="bold">Settings</p>
                                            <el-form :inline="true" class="fl">
                                                <el-form-item label="Repeat" class="first-label">
                                                    <el-switch :disabled="hasCompletedJob(cycle) === true" v-model="cycle.jobs[0].repeat"></el-switch>
                                                </el-form-item>
                                                <el-form-item label="Cycle name">
                                                    <el-input style="max-width: 150px" placeholder="Cycle Name" v-model="cycle.jobs[0].properties.cycle_name"></el-input>
                                                </el-form-item>
                                                <el-form-item label="Week amount">
                                                    <el-input style="max-width: 150px" :disabled="hasCompletedJob(cycle) === true" placeholder="Weeks in advance" v-model="cycle.jobs[0].properties.period_amount"></el-input>
                                                </el-form-item>

                                                <el-form-item label="Start cycle">
                                                    <el-date-picker
                                                        v-model="cycle.begin_time"
                                                        type="week"
                                                        :disabled="hasCompletedJob(cycle) === true"
                                                        format="'Week' WW-yyyy"
                                                        placeholder="Pick a week"
                                                        :picker-options=optionsBegin
                                                        :clearable=false
                                                        class="range-selector">
                                                    </el-date-picker>
                                                </el-form-item>

                                                <el-form-item label="Stores">
                                                    <el-select
                                                        v-model="cycle.jobs[0].properties.stores"
                                                        filterable
                                                        :clearable=true
                                                        :disabled="hasCompletedJob(cycle) === true"
                                                        multiple
                                                        collapse-tags
                                                        class="margin-left-xl"
                                                        style="width: 220px;"
                                                        placeholder="Filter stores"
                                                    >
                                                        <el-option
                                                            v-for="item in $store.getters['general/getStores']"
                                                            :key="item.store_id"
                                                            :label="item.store_name"
                                                            :value="item.store_id">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-form>
                                        </div>
                                    </div>
                                    <el-alert
                                        title="Something went wrong when saving the cycle"
                                        type="error"
                                        show-icon
                                        v-if="savingError === true && saving === false">
                                    </el-alert>
                                    <div class="row" style='margin-top:20px;'>
                                        <div class="col-12">
                                            <p class="bold">Jobs</p>
                                            <el-table
                                                :data="cycle.jobs"
                                                style="width: 100%; margin-bottom: 20px;"
                                            >
                                                <el-table-column
                                                    key="properties.level"
                                                    prop="properties.level"
                                                    label="Level"
                                                >
                                                </el-table-column>
                                                <el-table-column
                                                    key="type_name"
                                                    prop="type_name"
                                                    label="Description"
                                                >
                                                    <template slot-scope="scope">{{levelNames[scope.row.properties.level]}}</template>
                                                </el-table-column>
                                                <el-table-column
                                                    key="trigger_time"
                                                    prop="trigger_time"
                                                    label="Begin"
                                                >
                                                    <template slot-scope="scope">
                                                        <el-date-picker
                                                            v-model="scope.row.trigger_time"
                                                            type="datetime"
                                                            :disabled="scope.row.complete_time !== null"
                                                            placeholder="Select date and time"
                                                            format="yyyy-MM-dd HH:mm:ss"
                                                            value-format="yyyy-MM-dd HH:mm:ss">
                                                        </el-date-picker>
                                                        <el-alert
                                                            title="Make sure trigger times are sequential"
                                                            type="warning"
                                                            show-icon
                                                            style="max-width: 200px; display: inline; margin-left: 10px;"
                                                            :closable="false"
                                                            v-if="checkTriggerTimes === scope.row.job_id">
                                                        </el-alert>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                            <el-form :inline="true">
                                                <el-form-item label="Last level end time" class='time-label'>
                                                    <el-date-picker
                                                        v-model="cycle.end_time"
                                                        type="datetime"
                                                        placeholder="Select date and time">
                                                    </el-date-picker>
                                                    <el-alert
                                                        title="Make sure trigger times are sequential"
                                                        type="warning"
                                                        show-icon
                                                        style="max-width: 200px; display: inline; margin-left: 10px;"
                                                        :closable="false"
                                                        v-if="!isEndDateValid">
                                                    </el-alert>
                                                </el-form-item>
                                                <el-form-item v-show="hasCompletedJob(cycle) === true" label="Cycle not editable since one or more jobs have expired" class='time-label fr inline'></el-form-item>
                                            </el-form>
                                        </div>
                                    </div>
                                </template>
                            </el-tab-pane>
                        </el-tabs>
                        <div v-else style="width: 100%; margin: 50px auto; text-align: center;"><p>There are no cycles yet</p></div>
                    </el-card>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import { getHeadersWithAccessToken, getDateOfISOWeek, getWeekNumber } from '../../functions'
import axios from '@/services/axios.js'
import vue from 'vue'
export default {
    data () {
        return {
            activeName: '',
            cycles: [],
            loaded: false,
            levelNames: {},
            isAdmin: false,
            savingError: false,
            saving: false,
            cycleSaved: false,
            optionsBegin: { firstDayOfWeek: 1 }
        }
    },
    computed: {
        checkTriggerTimes () {
            let cycle = this.cycles.find(x => x.cycle_id === parseInt(this.activeName))
            let jobs = cycle.jobs
            for (let i in jobs) {
                for (let j in jobs) {
                    if (j < i && jobs[j].trigger_time > jobs[i].trigger_time) {
                        return jobs[i].job_id // Return job_id of job that has a wrong trigger time
                    }
                }
            }
            return false
        },
        // Checks if the end_time of the cycle is posterior to the trigger_time of the last job.
        isEndDateValid () {
            let cycle = this.cycles.find(x => x.cycle_id === parseInt(this.activeName))
            let jobs = cycle.jobs
            let end = new Date(cycle.end_time)
            let trigger = new Date(jobs[jobs.length - 1].trigger_time)
            return trigger < end
        }
    },
    methods: {
        hasCompletedJob (cycle) {
            if (cycle.firstJobCompleted) {
                return true
            }
            for (let job of cycle.jobs) {
                if (job.complete_time !== null) {
                    return true
                }
            }
            return false
        },
        openWarning () {
            this.$confirm('This will permanently delete this cycle. Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.deleteCycle()
            }).catch(() => {
            //
            })
        },
        addCycle () {
            let newCycle = {}
            return axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_SCHEDULER_API_BASE_URL_DEV : process.env.VUE_APP_SCHEDULER_API_BASE_URL) + '/cycle_create', { 'headers': getHeadersWithAccessToken() })
                .then(response => {
                    for (let item of response.data.data) {
                        if (item.properties.level > 0 && item.properties.level < 100) {
                            if (Object.entries(newCycle).length === 0 && newCycle.constructor === Object) {
                                newCycle = { 'end_time': response.data.data.find(x => x.properties.level === 100 && x.properties.cycle_id === item.properties.cycle_id).trigger_time, 'cycle_id': item.properties.cycle_id, 'cycle_name': item.properties.cycle_name, 'jobs': [item] }
                            } else {
                                newCycle['jobs'].push(item)
                            }
                        }
                    }
                    this.cycles.push(newCycle)
                    this.activeName = String(this.cycles[0].jobs[0].properties.cycle_id)
                })
                .catch(error => console.log(error))
        },
        deleteCycle () {
            let deleteCycle = this.cycles.find(x => x.cycle_id === parseInt(this.activeName))
            axios.delete(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_SCHEDULER_API_BASE_URL_DEV : process.env.VUE_APP_SCHEDULER_API_BASE_URL) + '/cycle?cycle_id=' + deleteCycle.cycle_id, { 'headers': getHeadersWithAccessToken() })
                .then(response => {
                    this.activeName = String(this.cycles[0].cycle_id)
                    let idx = this.cycles.indexOf(deleteCycle)
                    this.cycles.splice(idx, 1)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        saveCycle () {
            this.saving = true
            let saveCycle = this.cycles.find(x => x.cycle_id === parseInt(this.activeName))
            // Convert date object of start cycle to year + week and set for all jobs
            let year = getWeekNumber(saveCycle.begin_time)[0]
            let week = getWeekNumber(saveCycle.begin_time)[1]
            for (let j in saveCycle.jobs) {
                saveCycle.jobs[j].properties.year = year
                saveCycle.jobs[j].properties.week = week
                saveCycle.jobs[j].period_amount = parseInt(saveCycle.jobs[j].period_amount)
            }

            axios.put(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_SCHEDULER_API_BASE_URL_DEV : process.env.VUE_APP_SCHEDULER_API_BASE_URL) + '/cycle', { 'data': saveCycle.jobs, 'end_time': saveCycle.end_time }, { 'headers': getHeadersWithAccessToken() })
                .then(response => {
                    this.saving = false
                    this.cycleSaved = true
                    // eslint-disable-next-line
                    setTimeout(() => this.cycleSaved = false, 5000)
                })
                .catch(error => {
                    console.log(error)
                    this.savingError = true
                    this.saving = false
                    // eslint-disable-next-line
                    setTimeout(() => this.savingError = false, 5000)
                })
        }
    },

    created () {
        axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_BUDGET_API_BASE_URL_DEV : process.env.VUE_APP_BUDGET_API_BASE_URL) + '/level_names', { 'headers': getHeadersWithAccessToken() })
            .then(response => {
                this.levelNames = response.data.data
            })
            .catch(error => console.log(error))

        axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_SCHEDULER_API_BASE_URL_DEV : process.env.VUE_APP_SCHEDULER_API_BASE_URL) + '/cycle', { 'headers': getHeadersWithAccessToken() })
            .then(response => {
                if (response.data.data.length > 0) {
                    this.activeName = String(response.data.data[0].properties.cycle_id)
                    var cycles = []
                    var completedFirstJob = []
                    if (this.activeName !== undefined) {
                        for (let item of response.data.data) {
                            let id = item.properties.cycle_id
                            if (id !== undefined) {
                                if (item.properties.level === 0) {
                                    if (item.complete_time !== null) {
                                        completedFirstJob.push(item.properties.cycle_id)
                                    }
                                }
                                if (item.properties.level > 0 && item.properties.level < 100) { // in template don't show 0 and 100
                                    if (cycles.find(x => x.cycle_id === id) === undefined) { // Check if there is already a cycle object for this job
                                        cycles.push({ 'firstJobCompleted': false, 'begin_time': getDateOfISOWeek(item.properties.week, item.properties.year), 'end_time': response.data.data.find(x => x.properties.level === 100 && x.properties.cycle_id === id).trigger_time, 'cycle_id': id, 'cycle_name': item.properties.cycle_name, 'jobs': [item] })
                                    } else {
                                        let idx = cycles.indexOf(cycles.find(x => x.cycle_id === id))
                                        cycles[idx].jobs.push(item)
                                    }
                                }
                            }
                        }
                    }

                    for (let item of completedFirstJob) {
                        cycles.find(x => x.cycle_id === item)['firstJobCompleted'] = true
                    }
                    vue.set(this, 'cycles', cycles)
                }

                this.$store.dispatch('general/getStores').then(response => {
                    this.loaded = true
                })
            })
            .catch(error => {
                console.log(error)
            })
        axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/secrets', { headers: getHeadersWithAccessToken() })
            .then(response => {
                if (response.data.roles.includes(1)) {
                    this.isAdmin = true
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
}
</script>

<style lang="scss">
.component-settings-cycles {
    .el-date-editor {
        width: 220px !important;
        margin-left: 10px;
    }
    .el-label {
        margin: 0px 10px;
    }
    .el-table .cell {
        padding-left: 0px;
    }
    .el-form-item__label {
        margin-right: 5px;
        padding: 0px;
    }
    .first-label {
        .el-form-item__label {
            margin-left: 0px !important;
        }
    }
    .time-label {
        .el-form-item__label {
            margin-right: -2px !important;
        }
    }
    p.bold {
        margin-bottom: 0px;
        font-weight: 800;
    }

}
</style>
